import { SubmitHandler, useForm } from "react-hook-form";
import smiley from "assets/smily.png";
import smileyS from "assets/smilyS.png";
import smiley2 from "assets/smilyS-v2.png";
import { Button, Card } from "flowbite-react";
import { withPage } from "hoc/WithPages";

type Inputs = {
	name: string;
	company: string;
	email: string;
	phone: string;
	message: string;
};

const Partners = () => {
	const {
		formState: { errors },
		handleSubmit,
		register,
		watch,
	} = useForm<Inputs>();
	const onSubmit: SubmitHandler<Inputs> = (data) => console.log(data);

	return (
		<div className="w-screen mb-28">
			<section className="md:px-16 px-10 bg-teal py-16 md:py-28 mb-0 md:pb-96">
				<div className="flex gap-4 flex-col justify-start item-start md:w-[70%]">
					<h1 className="text-white">
						Partner with dead easy<span className="text-primary">.</span>
					</h1>
					<h4 className="text-white">
						ARE YOU A CHARITY, LEGAL FIRM OR FUNERAL DIRECTORS?
					</h4>
					<p className="text-white">
						Are you a charity, legal firm or funeral directors wanting to work
						with us? If so, please leave us a message below and someone from our
						team will call you back.
					</p>
				</div>
			</section>
			<section className="md:px-16 px-10 bg-darkblue py-16 md:py-28 mb-0 md:pt-96 relative">
				<div
					className="md:absolute md:top-[-50%] md:w-[80%] md:left-[50%] md:translate-x-[-50%]"
					// style={{ transform: "translateX(-50%)" }}
				>
					<Card className="mt-8 bg-primary dark:bg-primary border-8">
						<form onSubmit={handleSubmit(onSubmit)}>
							<div className="grid gap-6 mb-6 md:grid-cols-2">
								<div>
									<label className="block mb-2">Name</label>
									<input
										type="text"
										{...register("name")}
										className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full"
										required
									></input>
								</div>
								<div>
									<label className="block mb-2">Company</label>
									<input
										type="text"
										{...register("company")}
										className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full"
										required
									></input>
								</div>
								<div>
									<label className="block mb-2">Email</label>
									<input
										type="email"
										{...register("email")}
										className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full"
										required
									></input>
								</div>
								<div>
									<label className="block mb-2">Phone number</label>
									<input
										type="tel"
										{...register("phone")}
										className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full"
										required
									></input>
								</div>
							</div>
							<div>
								<label className="block mb-2">Message</label>
								<textarea
									{...register("message")}
									className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full"
									required
								></textarea>
							</div>
							{/* {errors.company && <span>This field is required</span>} */}
							<div className="flex justify-end">
								<Button
									pill
									type="submit"
									className="bg-darkblue dark:bg-darkblue mt-8"
								>
									Submit
								</Button>
							</div>
						</form>
					</Card>
					<div className="flex gap-4 justify-center mt-12">
						<img
							className="w-[60px] h-[60px] relative"
							alt="smiley"
							src={smiley}
						/>
						<img
							className="w-[60px] h-[60px] relative"
							alt="smiley"
							src={smiley2}
						/>
						<img
							className="w-[60px] h-[60px] relative"
							alt="smiley"
							src={smileyS}
						/>
					</div>
				</div>
			</section>
		</div>
	);
};

export default Partners;
